import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

export const initializeMsal = async () => {
  await msalInstance.initialize();

  const accounts = msalInstance.getAllAccounts();
  if (accounts?.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  msalInstance.addEventCallback(async (event) => {
    if (event.eventType === EventType.LOGOUT_START) {
     await msalInstance.logoutRedirect({
    postLogoutRedirectUri:
      typeof window !== "undefined" ? window.location.origin : undefined,
  });
    }

    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const { idTokenClaims } = event.payload.account;
      sessionStorage.setItem("azureId", idTokenClaims.sub);
      localStorage.setItem("azureId", idTokenClaims.sub);

      if (window?.klaviyo) {
        window.klaviyo.identify({
          $email: idTokenClaims?.email,
          $first_name: idTokenClaims?.given_name,
          $last_name: idTokenClaims?.family_name,
        });
      }

      msalInstance.setActiveAccount(event.payload.account);
    }
  });


};
